import { render, staticRenderFns } from "./insNote.vue?vue&type=template&id=07fa8533"
import script from "./insNote.vue?vue&type=script&lang=js"
export * from "./insNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports